import { useReducer } from "react";

const initialState = {
  recibo: {
    clienteCuit: "",
    numCliente: "",
    FechaDePago: { dia: "", mes: "", ano: "" },
    numRecibo: { ptoVta: "", numero: "" },
    usaReciboElectronico: false,
    efectivo: "",
    redondeo: "",
    idCliente: null,
    idTipoNegocio: null,
    totalEsperado: "",
  },

  retenciones: {
    retSuss: "",
    retGanancias: "",
    retIva: "",
    retDrei: "",
    retencionesIIBB: [],
  },

  instrumentos: [],
  tarjetas: [],
  imputaciones: [],
};

function receiptReducer(state, action) {
  switch (action.type) {
    case "RESET":
      return initialState;

    case "RECIBO_UPDATE":
      return {
        ...state,
        recibo: {
          ...state.recibo,
          [action.field]: action.value,
        },
      };

    case "RECIBO_FECHA_UPDATE":
      return {
        ...state,
        recibo: {
          ...state.recibo,
          FechaDePago: {
            ...state.recibo.FechaDePago,
            [action.field]: action.value,
          },
        },
      };

    case "RECIBO_NUMERO_UPDATE":
      return {
        ...state,
        recibo: {
          ...state.recibo,
          numRecibo: {
            ...state.recibo.numRecibo,
            [action.field]: action.value,
          },
        },
      };

    case "RETENCION_UPDATE":
      return {
        ...state,
        retenciones: {
          ...state.retenciones,
          [action.field]: action.value,
        },
      };

    case "ADD_IIBB":
      return {
        ...state,
        retenciones: {
          ...state.retenciones,
          retencionesIIBB: [
            ...state.retenciones.retencionesIIBB,
            { id: crypto.randomUUID(), provincia_id: "", importe: "" },
          ],
        },
      };

    case "UPDATE_IIBB":
      return {
        ...state,
        retenciones: {
          ...state.retenciones,
          retencionesIIBB: state.retenciones.retencionesIIBB.map((r, i) =>
            i === action.index ? { ...r, [action.field]: action.value } : r,
          ),
        },
      };

    case "REMOVE_IIBB":
      return {
        ...state,
        retenciones: {
          ...state.retenciones,
          retencionesIIBB: state.retenciones.retencionesIIBB.filter(
            (_, i) => i !== action.index,
          ),
        },
      };

    case "ADD_TARJETA":
      return {
        ...state,
        tarjetas: [
          ...state.tarjetas,
          {
            id: crypto.randomUUID(),
            tipo_id: null,
            banco_id: null,
            marca_id: null,
            lote: "",
            cupon: "",
            ultimos4: "",
            importe: "",
          },
        ],
      };

    case "UPDATE_TARJETA":
      return {
        ...state,
        tarjetas: state.tarjetas.map((tarj, i) =>
          i === action.index ? { ...tarj, [action.field]: action.value } : tarj,
        ),
      };

    case "REMOVE_TARJETA":
      return {
        ...state,
        tarjetas: state.tarjetas.filter((_, i) => i !== action.index),
      };

    case "ADD_INSTRUMENTO":
      return {
        ...state,
        instrumentos: [
          ...state.instrumentos,
          {
            id: crypto.randomUUID(),
            tipo_id: null,
            banco_id: null,
            nro_comprobante: "",
            dia: "",
            mes: "",
            ano: "",
            fecha_de_pago: "",
            importe: "",
            cuit_firma: "",
          },
        ],
      };

    case "UPDATE_INSTRUMENTO":
      return {
        ...state,
        instrumentos: state.instrumentos.map((inst, i) =>
          i === action.index ? { ...inst, [action.field]: action.value } : inst,
        ),
      };

    case "REMOVE_INSTRUMENTO":
      return {
        ...state,
        instrumentos: state.instrumentos.filter((_, i) => i !== action.index),
      };

    // Tarea #871: agrega una fila de instrumento ya resuelta por cada crédito QR elegido en
    // el diálogo de "Créditos QR disponibles". banco_id=Mercado Pago (72), tipo_id=QR (5).
    // dia/mes/ano se completan con la fecha de hoy porque cac_recibo_instrumento_bancario.fecha
    // es NOT NULL y el validador de instrumentos del front exige una fecha de emisión válida.
    case "ADD_INSTRUMENTOS_QR": {
      const hoy = new Date();
      return {
        ...state,
        instrumentos: [
          ...state.instrumentos,
          ...action.creditos.map((c) => ({
            id: crypto.randomUUID(),
            tipo_id: 5,
            banco_id: 72,
            nro_comprobante: c.referencia || c.detalle || String(c.id),
            dia: String(hoy.getDate()).padStart(2, "0"),
            mes: String(hoy.getMonth() + 1).padStart(2, "0"),
            ano: String(hoy.getFullYear()).slice(-2),
            fecha_de_pago: "",
            importe: c.importe,
            cuit_firma: "",
            pago_combinado_id: c.id,
            soloLecturaQr: true,
          })),
        ],
      };
    }

    case "ADD_IMPUTACION":
      return {
        ...state,
        imputaciones: [
          ...state.imputaciones,
          {
            id: crypto.randomUUID(),
            importe: null,
            id_factura: null,
            user: localStorage.getItem("user"),
          },
        ],
      };

    case "UPDATE_IMPUTACION":
      return {
        ...state,
        imputaciones: state.imputaciones.map((imp, i) =>
          i === action.index ? { ...imp, [action.field]: action.value } : imp,
        ),
      };

    case "REMOVE_IMPUTACION":
      return {
        ...state,
        imputaciones: state.imputaciones.filter((_, i) => i !== action.index),
      };

    case "SET_IMPUTACIONES":
      return {
        ...state,
        imputaciones: action.imputaciones,
      };

    default:
      return state;
  }
}

export function useReceiptReducer() {
  const [state, dispatch] = useReducer(receiptReducer, initialState);

  return { state, dispatch };
}
